module.exports = __webpack_public_path__ + "img/Picture9.3ca2fcf4.png";